module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.locations')))]), _vm._v(" "), _c('base-list', {
    attrs: {
      "model": "locations",
      "columns": ['name', 'contact_name'],
      "sModel": "location"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fde8ec20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/location/LocationList.vue
// module id = 1040
// module chunks = 2